export var SolutionType;
(function (SolutionType) {
    SolutionType["search"] = "search";
    SolutionType["listing"] = "listing";
    SolutionType["standalone"] = "standalone";
    SolutionType["recommendation"] = "recommendation";
})(SolutionType || (SolutionType = {}));
const recommendationOptionKey = 'recommendation-internal-options';
export const recommendationInternalOptionKey = Symbol.for(recommendationOptionKey);
